import { useState, useEffect } from "react";
import { TableCell } from "./TableCell";

export function CheckboxPreviewCell({ value }) {
  const [ownValue, setOwnValue] = useState(value ?? false);

  useEffect(() => {}, [ownValue]);
  return (
    <TableCell style={{ width: 120 }}>
      <div>
        <input type={"checkbox"} checked={ownValue} disabled />
      </div>
    </TableCell>
  );
}

export function CheckboxEditCell({ value, onChangeValue, valueType = "boolean" }) {
  const [ownValue, setOwnValue] = useState(value ?? false);
  const [oldValue, setOldValue] = useState(value);
  useEffect(() => {
    onChangeValue(ownValue);
  }, [ownValue]);
  return (
    <TableCell style={{ width: 120 }}>
      <div>
        <input
          type={"checkbox"}
          checked={ownValue}
          onChange={() => {
            setOwnValue(!ownValue);
          }}
        />
      </div>
    </TableCell>
  );
}
